export enum SimCollectStatus{
    CANCELLED = "CANCELLED", 
    COMPLETED = "COMPLETED", 
    CONFIRMED = "CONFIRMED", 
    PENDING = "PENDING"
}

export enum SimCollectType{
    SIM = "SIM",
    SIM2 = "SIM2",
    LIGHTSIM = "LIGHTSIM"
}

export class SimCollectRequestStatus{
    appointmentStatus: SimCollectStatus;
    
}



export class SimCollectRequestUpdate{
    appointmentStatus: SimCollectStatus;
    date: string;
    isFastwebCustomer: boolean;
    notes: string;
    pageUrl: string;
    
}



export class SimCollectRequestExportCSV{
    appointmentDateFrom: any;
    appointmentDateTo: any;
    isTargetMailList: boolean;
    status: string;
    storeAddress: string;
    storeCity: string;
    q: string;
}



export class SimCollectRequestSearch{
    appointmentDate: string;
    appointmentStatus: SimCollectStatus;
    pageNumber: number;
    pageSize: number;
    reservationDate: string;
    sortBy: string;
    storeAddress: string;
    storeCity: string;
    topicId: number;
    q: string;
    
}


export class SimCollectRequestAvailableCodes{
    total: number;
}